import { useState, useEffect } from 'react';

export default function useToggleClass(dependancies: string[] = []): boolean {
    const [isToggled, setIsToggled] = useState(false);
    useEffect(() => setIsToggled(true), [...dependancies]);

    return isToggled;
}
